<script lang="ts">
    import Modal from './Modal.svelte';
    import { createEventDispatcher } from 'svelte';

    export let show: boolean = false;
    export let distance: number = -1;

    const dispatch = createEventDispatcher();

    let showModal: boolean = false;

    $: showModal = show;

    $: if (!showModal) {
        dispatch('close');
    }

    function onContinue() {
        showModal = false;
    }

</script>

<style lang="scss">

    @use '../mixins';

    .too-far {
        position: relative;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        background-color: var(--color-fail);
    }

    .explanation {
        width: 100%;
        max-width: 300px;
        text-align: center;
        color: #fff;
        font-size: 24px;
    }

    .continue-btn {
        @include mixins.big-btn;
    }

</style>

{#if showModal}
<Modal>
    <div class="too-far">

        <div class="image">
            <img src="/images/too-far.svg" alt="">
        </div>

        <div class="explanation">
            <h1>Muy lejos...</h1>
            <slot>Para interactuar con este elemento <strong>debes estar a menos de {distance} m.</strong></slot>
        </div>

        <button type="button" class="continue-btn" on:click={onContinue}>
            ¡Entendido!
        </button>

    </div>
</Modal>
{/if}